import api from "./api";
import {
  IcmsStateRate,
  NcmTaxRate,
  TaxCalculation,
  TaxCalculationCommand,
  TaxRateImportResult,
} from "../models/Tax";

export const getTaxStatus = async (): Promise<{ lastImport?: string }> =>
  (await api.get("/api/tax/status")).data;

export const importTaxRates = async (): Promise<TaxRateImportResult> =>
  (await api.post("/api/tax/import", undefined, { timeout: 300000 })).data;

/** undefined quando o NCM não está nas tabelas. */
export const getNcmTaxRate = async (ncm: string): Promise<NcmTaxRate | undefined> => {
  try {
    return (await api.get(`/api/tax/ncm/${ncm.replace(/\D/g, "")}`)).data;
  } catch (error: any) {
    if (error?.response?.status === 404) return undefined;
    throw error;
  }
};

export const getContributionOverrides = async (): Promise<NcmTaxRate[]> =>
  (await api.get("/api/tax/contributions")).data;

export const setContributionOverride = async (ncm: string, pisRate?: number | null, cofinsRate?: number | null) =>
  (await api.put(`/api/tax/ncm/${ncm.replace(/\D/g, "")}/contributions`, { pisRate, cofinsRate })).data as NcmTaxRate;

export const getIcmsRates = async (): Promise<IcmsStateRate[]> => (await api.get("/api/tax/icms")).data;

export const updateIcmsRate = async (rate: IcmsStateRate) =>
  (await api.put(`/api/tax/icms/${rate.uf}`, {
    rate: rate.rate,
    effectiveRate: rate.effectiveRate ?? null,
    notes: rate.notes ?? null,
  })).data as IcmsStateRate;

export const calculateTaxes = async (command: TaxCalculationCommand): Promise<TaxCalculation> =>
  (await api.post("/api/tax/calculate", command)).data;
